import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import axiosInstance from "../services/axios";
// import { UserHeader } from "../components/UserHeader";
import { Footer } from "../components/footer";
import { useNavigate } from "react-router-dom";
import FileUploadModal from "./FileUploadModal";
import styles from "./css/ParentAreaPage.module.css";
import childrenTableStyles from "../components/children/ChildrenTable.module.css";
import childNotesStyles from "../components/children/css/ChildNotes.module.css";
import { CommentDto, FormDto, Category } from "../types/category.types";
import { safeLogger } from "../utils/logger";
import { showError } from "../utils/notifications";
import { baseURL } from "../services/axios";

export const ParentAreaPage = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const name = user?.name || "";
  const id = user?.code;
  const navigate = useNavigate();

  const [comments, setComments] = useState<CommentDto[]>([]);
  const [forms, setForms] = useState<FormDto[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [activeTab, setActiveTab] = useState<'notes' | 'forms'>('notes');
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editFileName, setEditFileName] = useState<string>("");
  const [editFile, setEditFile] = useState<File | null>(null);
  const [editCategoryId, setEditCategoryId] = useState<number>(0);

  useEffect(() => {
    safeLogger.log("Forms state updated");
  }, [forms]);

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        const [commentsRes, formsRes, categoriesRes] = await Promise.all([
          axiosInstance.get(`/Child/${id}/comments`),
          axiosInstance.get(`/Child/${id}/forms`),
          axiosInstance.get(`/FormCategory`),
        ]);

        setComments(commentsRes.data);
        setCategories(categoriesRes.data);
        setForms(
          formsRes.data.map((form: any) => {
            // תמיכה בשמות שדה שונים מהשרת
            let formCategoryId = form.formCategoryId ?? form.formCategoryCode ?? form.FormCategoryCode;
            if (typeof formCategoryId === "string") formCategoryId = Number(formCategoryId);
            const found = categoriesRes.data.find((c: Category) => c.code === formCategoryId);
            return { ...form, formCategoryId, categoryName: found?.categoryName || "" };
          })
        );
      } catch (error) {
        console.error("Error loading child data", error);
      }
    };

    fetchData();
  }, [id]);

  const handleFormUploaded = (newForm: FormDto) => {
    safeLogger.log("New form uploaded");
    // ודא שתמיד יש categoryName בטופס החדש
  let formCategoryId = newForm.FormCategoryId;
  if (typeof formCategoryId === "string") formCategoryId = Number(formCategoryId);
  const found = categories.find(c => c.code === formCategoryId);
  const categoryName = found?.categoryName || "";
  const formToAdd = { ...newForm, CategoryName: categoryName, FormCategoryId: formCategoryId };
    safeLogger.log("Adding form to list");
    
    setForms(prev => {
      const updated = [...prev, formToAdd];
      safeLogger.log("Forms list updated");
      return updated;
    });
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("האם למחוק את הטופס?")) return;
    try {
      await axiosInstance.delete(`/Form/${id}`);
      setForms(forms => forms.filter(f => f.Id !== id));
    } catch (err) {
      showError("שגיאה במחיקה");
    }
  };

  const handleEdit = (idx: number) => {
  const form = forms[idx];
  setEditIndex(idx);
  setEditFileName(form.FileName);
  setEditCategoryId(form.FormCategoryId ?? 0);
  setEditFile(null);
  };

  const fetchData = async () => {
    try {
      const [commentsRes, formsRes, categoriesRes] = await Promise.all([
        axiosInstance.get(`/Child/${id}/comments`),
        axiosInstance.get(`/Child/${id}/forms`),
        axiosInstance.get(`/FormCategory`),
      ]);

      setComments(commentsRes.data);
      setCategories(categoriesRes.data);
      setForms(
        formsRes.data.map((form: any) => {
          // תמיכה בשמות שדה שונים מהשרת
          let formCategoryId = form.formCategoryId ?? form.formCategoryCode ?? form.FormCategoryCode;
          if (typeof formCategoryId === "string") formCategoryId = Number(formCategoryId);
          const found = categoriesRes.data.find((c: Category) => c.code === formCategoryId);
          return { ...form, formCategoryId, categoryName: found?.categoryName || "" };
        })
      );
    } catch (error) {
      safeLogger.error("Error loading child data");
    }
  };

  const handleSaveEdit = async (form: FormDto) => {
    try {
      if (!form.Id) {
        showError("מזהה הטופס חסר");
        return;
      }
      const formData = new FormData();
      formData.append("Id", form.Id.toString());
      formData.append("FileName", editFileName);
      formData.append("FormCategoryCode", editCategoryId.toString());
      if (editFile) {
        formData.append("FormFile", editFile);
      }
      await axiosInstance.put(`/Form/${form.Id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      await fetchData();
      setEditIndex(null);
      setEditFileName("");
      setEditFile(null);
      setEditCategoryId(0);
    } catch (err) {
      showError("שגיאה בעדכון");
    }
  };

  const handleCancelEdit = () => {
    setEditIndex(null);
    setEditFile(null);
  };

  return (
    <div className={styles.container}>
      {/* <UserHeader /> */}
      <div className={styles.test123}>בדיקת טעינת CSS MODULE</div>
      <main className={styles.mainContent}>
        <h2 className={childNotesStyles.pageTitle} style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#471f1f', fontWeight: 700, textAlign: 'center', paddingBottom: '12px', position: 'relative' }}>
          שלום להורים של {name}
          <span style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80px',
            height: '3px',
            background: 'linear-gradient(to right, #a2b087, #ba9484)',
            borderRadius: '2px',
            display: 'block'
          }}></span>
        </h2>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '24px', marginBottom: '2.5rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: '1rem', color: '#471f1f', marginBottom: 6 }}>הערות המנתחת</span>
            <button
              style={{
                borderRadius: 12,
                border: activeTab === 'notes' ? '2px solid #a2b087' : '2px solid #eec0c6',
                background: activeTab === 'notes' ? '#eec0c6' : '#fff',
                color: '#471f1f',
                fontWeight: 600,
                fontSize: '1.1rem',
                padding: '16px 38px',
                boxShadow: activeTab === 'notes' ? '0 4px 15px rgba(162,176,135,0.13)' : '0 2px 8px rgba(220,200,236,0.08)',
                cursor: 'pointer',
                outline: 'none',
                transition: 'all 0.2s',
                minWidth: 120,
                marginBottom: 0
              }}
              onClick={() => setActiveTab('notes')}
            >
              תוכניות עבודה
            </button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: '1rem', color: '#471f1f', marginBottom: 6 }}>טפסים</span>
            <button
              style={{
                borderRadius: 12,
                border: activeTab === 'forms' ? '2px solid #a2b087' : '2px solid #eec0c6',
                background: activeTab === 'forms' ? '#eec0c6' : '#fff',
                color: '#471f1f',
                fontWeight: 600,
                fontSize: '1.1rem',
                padding: '16px 38px',
                boxShadow: activeTab === 'forms' ? '0 4px 15px rgba(162,176,135,0.13)' : '0 2px 8px rgba(220,200,236,0.08)',
                cursor: 'pointer',
                outline: 'none',
                transition: 'all 0.2s',
                minWidth: 120,
                marginBottom: 0
              }}
              onClick={() => setActiveTab('forms')}
            >
              טפסים
            </button>
          </div>
        </div>

        {activeTab === 'forms' && (
          <div className={childrenTableStyles.tableContainer} style={{ maxWidth: 1000, margin: '2rem auto', width: '100%' }}>
            <table className={childrenTableStyles.table}>
              <thead>
                <tr>
                  <th>שם הטופס</th>
                  <th>קטגוריה</th>
                  <th>צפייה</th>
                  <th>פעולות</th>
                </tr>
              </thead>
              <tbody>
                {forms.length === 0 ? (
                  <tr>
                    <td colSpan={4} style={{ textAlign: 'center', padding: '2rem', color: '#666', background: 'rgba(255,255,255,0.7)' }}>
                      אין טפסים להצגה
                    </td>
                  </tr>
                ) : (
                  forms.map((f, i) => (
                    <tr key={i} className={childrenTableStyles.tableRow}>
                      <td>
                        {editIndex === i ? (
                          <input
                            value={editFileName}
                            onChange={e => setEditFileName(e.target.value)}
                            style={{ width: "100%", borderRadius: 8, border: '1px solid #a2b087', padding: 6 }}
                          />
                        ) : (
                          f.FileName
                        )}
                      </td>
                      <td>
                        {editIndex === i ? (
                          <select
                            value={editCategoryId}
                            onChange={e => {
                              const id = Number(e.target.value);
                              setEditCategoryId(id);
                            }}
                            style={{ borderRadius: 8, border: '1px solid #a2b087', padding: 6 }}
                          >
                            <option value="">בחר קטגוריה</option>
                            {categories.map((c) => (
                              <option key={c.code} value={c.code}>
                                {c.categoryName}
                              </option>
                            ))}
                          </select>
                        ) : (
                          (() => {
                            const foundCategory = categories.find(c => c.code === f.FormCategoryId);
                            return foundCategory?.categoryName || "ללא קטגוריה";
                          })()
                        )}
                      </td>
                      <td>
                        <a
                          href={`${baseURL}${f.FileUrl}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#ba9484', fontWeight: 600, textDecoration: 'underline', fontSize: '1rem' }}
                        >
                          לצפייה בטופס
                        </a>
                        {editIndex === i && (
                          <>
                            <button className={styles.downloadButton} title="שמירה" onClick={() => handleSaveEdit(f)}>
                              <span role="img" aria-label="save">💾</span>
                            </button>
                            <button className={styles.cancelButton} title="ביטול" onClick={handleCancelEdit}>
                              <span role="img" aria-label="cancel">❌</span>
                            </button>
                          </>
                        )}
                      </td>
                      <td>
                        {editIndex === i ? (
                          <>
                            <button className={styles.actionBtn} title="שמירה" onClick={() => handleSaveEdit(f)}>
                              ✔️
                            </button>
                            <button className={styles.actionBtn} title="ביטול" onClick={handleCancelEdit}>
                              ❌
                            </button>
                          </>
                        ) : (
                          <>
                            <button className={styles.editButton} title="עריכה" onClick={() => handleEdit(i)}>
                              <span role="img" aria-label="edit">✏️</span>
                            </button>
                            <button className={styles.deleteButton} title="מחיקה" onClick={() => f.Id !== undefined ? handleDelete(f.Id) : null}>
                              <span role="img" aria-label="delete">🗑️</span>
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {/* כפתור העלאת טופס חדש למטה */}
            <FileUploadModal onFormUploaded={handleFormUploaded} />
          </div>
        )}

        {activeTab === 'notes' && (
          <div className={childrenTableStyles.tableContainer} style={{ maxWidth: 1000, margin: '2rem auto', width: '100%' }}>
            <table className={childrenTableStyles.table}>
              <thead>
                <tr>
                  <th>הערה</th>
                  <th>תאריך</th>
                </tr>
              </thead>
              <tbody>
                {comments.map((c, i) => (
                  <tr key={i} className={childrenTableStyles.tableRow}>
                    <td style={{ textAlign: 'right' }}>{c.comments}</td>
                    <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{new Date(c.date).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
  {/* Footer אחד בלבד בתחתית */}
  <Footer />
    </div>
  );
};